import React from 'react';
import { Box, BoxProps } from '@material-ui/core';
import invariant from 'invariant';
import PageHeaderBackLink from '€components/PageHeaderBackLink';
import PageHeaderTitle from '€components/PageHeaderTitle';
import { Hidden } from '€components/Hidden';

interface PageHeaderProps extends BoxProps {
    backPath?: string;
    title?: string;
    subtitle?: string;
    backText?: string;
    rightComponent?: React.ReactNode;
    historyBack?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
    backPath,
    backText,
    title,
    subtitle,
    rightComponent,
    historyBack,
    ...props
}: PageHeaderProps) => {
    invariant(!(backPath && historyBack), 'Cannot parse "backPath" if "historyBack === true"');

    invariant(
        (!historyBack && backPath) || (!backPath && backText),
        'Must supply "backText" if passing "backPath" or "historyBack === true',
    );

    return (
        <>
            <Hidden xsDown>
                <Box mt={5}>
                    <Box ml="-.375rem">
                        {(backPath || historyBack) && (
                            <PageHeaderBackLink path={backPath} text={backText} />
                        )}
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        height={47}
                        {...props}
                    >
                        {(title || subtitle) && (
                            <PageHeaderTitle centered={false} title={title} subtitle={subtitle} />
                        )}
                        {rightComponent}
                    </Box>
                </Box>
            </Hidden>
            <Hidden smUp>
                <Box
                    display="flex"
                    px={3}
                    height={52}
                    borderBottom="1px solid rgba(2, 69, 85, 0.2);"
                    {...props}
                >
                    <Box
                        display="flex"
                        flex={1}
                        justifyContent={rightComponent ? 'space-between' : 'center'}
                        alignItems="center"
                        position="relative"
                        maxWidth="100%"
                    >
                        {!rightComponent && backPath && (
                            <Box position="absolute" marginLeft={-1} left={0}>
                                <PageHeaderBackLink path={backPath} text={backText} />
                            </Box>
                        )}

                        {!rightComponent && (
                            <PageHeaderTitle
                                centered={!rightComponent}
                                title={title}
                                subtitle={subtitle}
                                maxWidth="calc(80%)"
                            />
                        )}

                        {rightComponent && backPath && (
                            <Box display="flex" alignItems="center" marginLeft={-1}>
                                <PageHeaderBackLink path={backPath} />
                                <PageHeaderTitle
                                    centered={false}
                                    title={title}
                                    subtitle={subtitle}
                                />
                            </Box>
                        )}

                        {rightComponent}
                    </Box>
                </Box>
            </Hidden>
        </>
    );
};

export default PageHeader;
